import type { PlatformId, PlatformLimits } from "@/types/platforms";

export const PLATFORM_LIMITS: Record<PlatformId, PlatformLimits> = {
  youtube: {
    titleMaxLength: 100,
    descriptionMaxLength: 5000,
    maxTags: 12, // VidSeeds.ai limit — 5-8 is the sweet spot; >12 triggers spam suppression. YouTube hard limit is 500 chars total.
    maxHashtags: 0,
    maxVideoLength: 43200, // 12 hours
    maxFileSize: 256 * 1024 * 1024 * 1024, // 256GB
    supportedAspectRatios: ["16:9", "9:16", "1:1", "4:3"],
    supportsScheduling: true,
    supportsDirectUpload: true,
  },
  tiktok: {
    titleMaxLength: 0, // TikTok uses description only
    descriptionMaxLength: 2200,
    maxTags: 0,
    maxHashtags: 5,
    maxVideoLength: 600, // 10 min
    maxFileSize: 4 * 1024 * 1024 * 1024,
    supportedAspectRatios: ["9:16", "1:1"],
    supportsScheduling: false,
    supportsDirectUpload: true,
  },
  instagram: {
    titleMaxLength: 0,
    descriptionMaxLength: 2200,
    maxTags: 0,
    maxHashtags: 30,
    maxVideoLength: 5400, // 90 min (Reels up to 15 min)
    maxFileSize: 3.6 * 1024 * 1024 * 1024,
    supportedAspectRatios: ["9:16", "1:1", "4:5"],
    supportsScheduling: true,
    supportsDirectUpload: true,
  },
  facebook: {
    titleMaxLength: 0,
    descriptionMaxLength: 63206,
    maxTags: 0,
    maxHashtags: 5,
    maxVideoLength: 14400, // 4 hours
    maxFileSize: 10 * 1024 * 1024 * 1024,
    supportedAspectRatios: ["16:9", "9:16", "1:1"],
    supportsScheduling: true,
    supportsDirectUpload: true,
  },
  linkedin: {
    titleMaxLength: 0,
    descriptionMaxLength: 3000,
    maxTags: 0,
    maxHashtags: 3,
    maxVideoLength: 900, // 15 minutes
    maxFileSize: 5 * 1024 * 1024 * 1024,
    supportedAspectRatios: ["16:9", "1:1", "9:16"],
    supportsScheduling: false,
    supportsDirectUpload: true,
  },
  x: {
    titleMaxLength: 0,
    descriptionMaxLength: 280,
    maxTags: 0,
    maxHashtags: 5,
    maxVideoLength: 140,
    maxFileSize: 512 * 1024 * 1024,
    supportedAspectRatios: ["16:9", "1:1"],
    supportsScheduling: false,
    supportsDirectUpload: true,
  },
};

export const PLATFORM_METADATA_LIMITS = Object.fromEntries(
  Object.entries(PLATFORM_LIMITS).map(([platform, limits]) => [
    platform,
    {
      titleMax: limits.titleMaxLength,
      descriptionMax: limits.descriptionMaxLength,
      maxTags: limits.maxTags,
      maxHashtags: limits.maxHashtags,
    },
  ]),
) as Record<
  PlatformId,
  {
    titleMax: number;
    descriptionMax: number;
    maxTags: number;
    maxHashtags: number;
  }
>;
